import React, { useEffect, useState } from 'react'
import { CareTeam as FHIRCareTeam } from '@teschglobal/tg-fhir-react-components/dist/types'
import { useHistory } from 'react-router-dom'
import { CareTeamBundle } from '../../../../../types/FHIRTypes/Bundle'
import FhirLoader from '../../../../FhirLoader'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { CareTeam } from '@teschglobal/tg-fhir-react-components'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type CareTeamDetailProps = {
  careTeamDetailId: string
}

const CareTeamDetail: React.FC<CareTeamDetailProps> = ({ careTeamDetailId}) => {
  const [resource, setResource] = useState<FHIRCareTeam | null>(null)

  const { patientAccessFhirConfig } = useFhirConfig()
  const history = useHistory()

  const {
    data: careTeam,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRCareTeam, Error> =
    useFhirResourceById('Patient Access', careTeamDetailId || '', 'CareTeam')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!careTeam || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }


  return (
    <div>
      <section>
        <CareTeam
          data={careTeam}
          fhirApiConfig={patientAccessFhirConfig}
        />
      </section>
    </div>
  )
}

export default CareTeamDetail